import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

class PlyrVideo {
  static init() {
    const videos = document.querySelectorAll('video.js-plyr-video');

    if (!videos.length) {
      return;
    }

    videos.forEach((video) => {
      if (video.dataset.plyrInitialized === 'true') {
        return;
      }

      new Plyr(video, {
        controls: [
          'play-large',
          'play',
          'progress',
          'current-time',
          'mute',
          'volume',
          'fullscreen',
        ],
        keyboard: {
          focused: true,
          global: true,
        },
        resetOnEnd: true,
      });

      video.dataset.plyrInitialized = 'true';
    });
  }
}

export default PlyrVideo;
